import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
import Index from '@/pages/Index'
import Home from '@/pages/Home'
import DownLoad from '@/pages/DownLoad'
import About from '@/pages/About'
import Join from '@/pages/Join'
import { networkInterfaces } from 'os'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/pages/Index',
      name: 'Index',
      component: Index
    },
    {
      path: '/pages/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/pages/DownLoad',
      name: 'DownLoad',
      component: DownLoad
    },
    {
      path: '/pages/About',
      name: 'About',
      component: About
    }
    ,
    {
      path: '/pages/Join',
      name: 'Join',
      component: Join
    }
  ]
})
router.beforeEach((to, from, next) => {
  store._actions.setSubmenu[0](to.name)
  next()
})
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js